export const optionsIsSame = (opt1, opt2) => opt1.value === opt2.value;
